module.exports = "/_next/static/images/3-545ec2f4ec15bd61a6d99c37d0bb9e77.jpg";